// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"0a6c1b4b","188":"5e0848e8","231":"a1401360","442":"99df154f","453":"94963f27","764":"5b52a9c2","874":"991f1b8a","879":"b3fe11e2","917":"6d35cc0c","998":"0cb32b4f"}[chunkId] + ".chunk.js";
};